import { HttpErrorResponse } from '@angular/common/http';
import { createSelector } from 'reselect';
import { Action } from '@ngrx/store';
import { AppState } from '../../../app.state';

import { Form, Answer } from '../../../shared/models/form.model';

import * as reasonFormActions from './reason-form.actions';

import { sortBy } from 'lodash';

export interface AnswersByPatient {
  [key: number]: Answer[];
}

export interface State {
  readonly form: Form;
  readonly answers: AnswersByPatient;
  readonly currentQuestion: number;
}

const initialState: State = {
  form: {} as Form,
  answers: {},
  currentQuestion: null,
};

export function reasonFormReducer(state = initialState, action: Action): State {
  switch (action.type) {
    case reasonFormActions.actionTypes.SET_FORM:
      const form = action.payload;
      let currentQuestion = null;

      if (form.questions && form.questions.length) {
        currentQuestion = (sortBy(form.questions, 'displaySequence')[0] as any).id;
      }

      return {
        ...state,
        form,
        currentQuestion,
      };

    case reasonFormActions.actionTypes.SET_CURRENT_QUESTION:
      return {
        ...state,
        currentQuestion: action.payload,
      };

    case reasonFormActions.actionTypes.SET_ANSWER:
      const patientId = Object.keys(action.payload)[0];

      if (state.answers[patientId]) {
        return {
          ...state,
          answers: {
            ...state.answers,
            [patientId]: [
              ...state.answers[patientId],
              ...Object.values(action.payload),
            ]
          },
        };        
      }
      return {
        ...state,
        answers: {
          ...state.answers,
          [patientId]: [
            ...Object.values(action.payload),
          ]
        },
      };

    case reasonFormActions.actionTypes.RESET_ANSWERS:
      return {
        ...state,
        answers: {},
      };

    case reasonFormActions.actionTypes.RESET_FORM:
      return initialState;

    default:
      return state;
  }
}

export const getReasonFormState = (state: AppState) => state.reasonForm;

export const getQuestions = createSelector(getReasonFormState, (state: State) => state.form);
export const getCurrentQuestion = createSelector(getReasonFormState, (state: State) => state.currentQuestion);
export const getAnswers = createSelector(getReasonFormState, (state: State) => state.answers);



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/reasons/reason-form/reason-form.reducer.ts